import axios from 'axios'
import { message } from 'antd'
import { BASE_URLS } from 'config/const'
// 创建 axios 实例
const request = axios.create({
  timeout: 30000 // 请求超时时间
})
// if (process.env.NODE_ENV === 'development') {
// 	console.log('development', process.env.REACT_APP_BASE_URL);
// 	axios.defaults.baseURL = '/';
// } else if (process.env.NODE_ENV === 'test') {
// 	console.log('alpha', process.env.REACT_APP_BASE_URL);
// 	axios.defaults.baseURL = process.env.REACT_APP_BASE_URL;
// } else {
// 	console.log('prod', process.env.REACT_APP_BASE_URL);
// 	axios.defaults.baseURL = process.env.REACT_APP_BASE_URL;
// }
axios.defaults.baseURL = BASE_URLS[process.env.REACT_APP_ENV]
// 异常拦截处理器
const errorHandler = (error: any) => {
  if (error.response) {
    const { data } = error.response

    const token = localStorage.getItem('token')
    if (error.response.status === 403) {
      message.error(403 + data.error)
    }
    if (error.response.status === 401) {
      window.location.href = '/login.html'
    }
  }
  return Promise.reject(error)
}

// request interceptor
request.interceptors.request.use(config => {
  console.log('process.env.REACT_APP_ENV', process.env.REACT_APP_ENV, BASE_URLS[process.env.REACT_APP_ENV], axios.defaults.baseURL);
  
  const token = localStorage.getItem('token')
  config.headers.token = token
  // 如果 token 存在
  // 让每个请求携带自定义 token 请根据实际情况自行修改
  // if (token) {
  //   config.headers.Authorization = 'Bearer ' + token
  // }
  return config
}, errorHandler)

// response interceptor
request.interceptors.response.use(response => response, errorHandler)
export default request
